<template>
  <div :id="random_id"
       v-bind="$attrs"
       :data-testid="dataTestid"
       :class="twMerge(props.appendClass)"
  >

    <TsCard
            :appendClass="twMerge(backgroundColorClass, 'rounded-md py-2.5 max-lg:pr-2 max-lg:pl-2.5 lg:py-4')"
            no-border no-shadow
            cardContentClass="w-full mx-auto p-0"
            type="horizontal"
            :data-testid="`${dataTestid}-card`">
      <template #default>
        <TsRow :class="twMerge(`justify-center items-center gap-x-2`, props.rowClass)" no-gutter>
          <TsColumn class="is-4 lg:is-3">
            <TsImage :class="twMerge(props.imageClass, 'w-full my-auto text-right')"
                     :src="image"
                     :alt="alt"
                     :data-testid="`${dataTestid}-image`" loading="lazy"/>
          </TsColumn>
          <TsColumn :class="twMerge(`lg:max-w-max ${props.colClass}`)">
            <TsTypography appendClass="mb-0" :variant="isMobile ? 'h4' : 'h3'" as="div">
              <slot name="heading">
                {{ props.heading }}
              </slot>
            </TsTypography>
            <TsTypography appendClass="mb-0" as="p">
              <slot name="description">
                {{ props.description }}
              </slot>
            </TsTypography>
          </TsColumn>
        </TsRow>
      </template>
    </TsCard>
  </div>
</template>

<script setup lang="ts">
import { useRandomUUID } from "~/composables/useRandomUUID";
import { twMerge } from "tailwind-merge";
import { onMounted, ref } from "vue";
const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

const { isMobile } = useDevice();

type Props = {
  appendClass?: string;
  imageClass?: string;
  heading?: string;
  headingClass?: string;
  description?: string;
  descriptionClass?: string;
  image?: string;
  backgroundColorClass?: string;
  dataTestid?: string;
  rowClass?: string;
  colClass?: string;
  alt?:string;
};

const props = withDefaults(defineProps<Props>(), {
  heading: '7 Days',
  description: 'Available',
  image: '/images/cardImage.webp',
  imageClass: '',
  backgroundColorClass: 'bg-[#eaecf9]',
});

const random_id = ref('');
onMounted(() => {
  random_id.value = useRandomUUID();
});
</script>

